// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fold-container[data-v-0aa18f66]{display:flex}.fold-container-y[data-v-0aa18f66]{flex-direction:column}.fold-container-x[data-v-0aa18f66]{flex-direction:row}.fold-container-x>div[data-v-0aa18f66]{overflow:hidden;transition:all .3s}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
